import { gsap } from "gsap";

import { Observer } from "gsap/Observer";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// ScrollSmoother requires ScrollTrigger
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

function initParallax() {

    if (window.innerWidth < 1200) {
        return; // Disabilita l'effetto parallax su dispositivi mobili
    }

    if (document.querySelectorAll('.el-parallax-1').length > 0) {
        initParallaxEffect('#categories', '.el-parallax-1', 2.5);
    }

    if (document.querySelectorAll('.el-parallax-2').length > 0) {
        initParallaxEffect('#special-projects', '.el-parallax-2', 2.5);
    }
}

function initParallaxEffect(container, selector, speed) {

    const maxMove = 300;
    const minMove = -300;

    var containerElement = document.querySelector(container);
    var tl = gsap.timeline({
        scrollTrigger: {
            trigger: container,
            start: "top bottom",
            end: "bottom bottom",
            scrub: 0.1,
            // markers: true,
            invalidateOnRefresh: true,
        }
    });

    // Applica will-change: transform a tutti gli elementi target
    containerElement.querySelectorAll(selector).forEach(el => {
        el.style.willChange = 'transform';
    });

    tl.to(selector, {
        y: (i, target) => {
            const rect = containerElement.getBoundingClientRect();
            const offset = rect.top + window.scrollY;
            let move = (window.scrollY - offset) * speed;
            move = Math.max(minMove, Math.min(maxMove, move));
            return move;
        },
        ease: "power1.out",
    });

    window.addEventListener('resize', () => {
        tl.invalidate(); // Ricalcola le posizioni al resize
    });

}

export function initHomeModule() {

    if (document.querySelectorAll('.home-hero-swiper').length > 0) {
        initializeSwiper('.home-hero-swiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            speed: 500,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                enabled: true,
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }

    if (document.querySelectorAll('.ambienti-swiper').length > 0) {
        // Ambienti swiper per la home page
        initializeSwiper('.ambienti-swiper', {
            slidesPerView: 1.25,
            spaceBetween: 20,
            loop: false,
            scrollbar: {
                enabled: true,
                el: '.swiper-scrollbar',
                draggable: true,
            },
            breakpoints: {
                992: {
                    slidesPerView: 2.25,
                    scrollbar: {
                        enabled: true,
                    },
                },
                1400: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                    grid: {
                        rows: 1,
                        fill: 'rows',
                    },
                    scrollbar: {
                        enabled: false,
                    },
                },
            },
        });
    }

    if (document.querySelectorAll('.projects-home-swiper').length > 0) {
        // Projects swiper per la home page
        initializeSwiper('.projects-home-swiper', {
            slidesPerView: 1.25,
            spaceBetween: 40,
            loop: false,
            lazy: true,
            loadPrevNext: true,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
                1400: {
                    slidesPerView: 4,
                },
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
        });
    }

    if (document.querySelectorAll('.magazine-home-swiper').length > 0) {
        // Magazine swiper per la home page
        initializeSwiper('.magazine-home-swiper', {
            slidesPerView: 1.20,
            spaceBetween: 40,
            loop: false,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            navigation: {
                nextEl: '.slider-button-next',
                prevEl: '.slider-button-prev',
            },
            breakpoints: {
                576: {
                    slidesPerView: 1.5,
                },
                992: {
                    slidesPerView: 2,
                },
                1400: {
                    slidesPerView: 3,
                },
            },
        });
    }

    initParallax();
}
